import React from "react";
import { Banner, InlineStack, ProgressBar, Spinner, Text } from '@shopify/polaris';

export default function SyncProgressBanner({ progress, message }: { progress: number, message: string }) {
    return (
        <div style={{marginBottom: 16}}>
            <Banner tone="info" title="Syncing products">
                <InlineStack align="center" gap="200">
                    <div style={{ flex: 1 }}>
                        <ProgressBar progress={progress} size="medium" tone={"success"} />
                        <Text variant="bodyMd" tone="subdued" as={"p"}>{message}</Text>
                    </div>
                    {progress < 100 && <Spinner size="small" />}
                </InlineStack>
            </Banner>
        </div>
    );
}
